import { Platform } from '@angular/cdk/platform';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { DateFormat } from 'src/app/core/class/date-format';
import dayjs from 'dayjs';

interface IReportCriterionRow {
  code: string;
  name: string;
  inputType: string;
  order?: number;
  parentCode?: string;
  controlField?: any;
  displayOrder?: string;
  level?: number;
  rowType: 'header' | 'subheader' | 'criterion';
  expanded?: boolean;
  treeKey: string;
  parentTreeKey: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-view-properties-dialog-digital',
  styleUrls: ['./view-properties-dialog-digital.component.scss'],
  templateUrl: './view-properties-dialog-digital.component.html',
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: 'vi' },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ViewPropertiesDialogDigitalComponent implements OnInit {
  listDataSource: any[] = [];
  listDataTable: IReportCriterionRow[] = [];
  listDataUpdateSource: any[] = [];
  listDataUpdateTable: IReportCriterionRow[] = [];
  customerMohaId: any = null
  customerMohaName: any = null
  listCustomer: any[] = [];
  optionsMap = new Map<number, any[]>();
  displayedColumns = ["stt", "nameCriteria", "infoTemplate"];
  headerColumns = ["groupHeader"];
  isOriginalContract: boolean = false;
  titleChange: string = '';
  private readonly expandedGroups = new Map<string, boolean>();
  private readonly parentTreeKeyMap = new Map<string, string>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewPropertiesDialogDigitalComponent>,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    this.listDataUpdateSource = this.data.listDataUpdateSource
    this.listDataSource = this.data.listDataSource
    this.listDataUpdateTable = this.buildTableRows(this.listDataUpdateSource, 'update')
    this.listDataTable = this.buildTableRows(this.listDataSource, 'default')
    this.customerMohaId = this.data.customerMohaId
    this.customerMohaName = this.data.customerMohaName
    this.listCustomer = this.data.listCustomer
    this.optionsMap = this.data.optionsMap
    this.isOriginalContract = this.data.isOriginalContract;
    this.titleChange = this.data.titleChange;
  }

  onNoClick() {
    this.dialogRef.close();
  }

  private buildTableRows(source: any[], tableKey: string): IReportCriterionRow[] {
    const nodes: IReportCriterionRow[] = (source || [])
      .filter(item => !!item && !!item.code)
      .map(item => {
        const treeKey = `${tableKey}:${item.code}`;
        return {
          ...item,
          treeKey,
          parentTreeKey: item.parentCode ? `${tableKey}:${item.parentCode}` : '',
          expanded: item.inputType === 'HEADER'
            ? (this.expandedGroups.has(treeKey) ? this.expandedGroups.get(treeKey) : true)
            : undefined,
          rowType: item.inputType === 'HEADER' ? 'header' : 'criterion'
        };
      });

      const existingCodes = new Set(nodes.map(n => n.code));

      const childrenMap = new Map<string, IReportCriterionRow[]>();
      nodes.forEach(node => {
        const parentCode = node.parentCode && existingCodes.has(node.parentCode)
          ? node.parentCode
          : '';
        this.parentTreeKeyMap.set(node.treeKey, node.parentTreeKey || '');
        const children = childrenMap.get(parentCode) || [];
        children.push(node);
        childrenMap.set(parentCode, children);
      });

    const effectiveOrder = (node: IReportCriterionRow): number => {
      const children = childrenMap.get(node.code) || [];
      return node.inputType === 'HEADER' && children.length
        ? Math.min(...children.map(effectiveOrder))
        : Number(node.order || 0);
    };
    childrenMap.forEach(children =>
      children.sort((first, second) => effectiveOrder(first) - effectiveOrder(second))
    );

    const rows: IReportCriterionRow[] = [];
    let runningOrder = 0;
    const appendNode = (node: IReportCriterionRow, displayOrder: string, level: number) => {
      const isHeader = node.inputType === 'HEADER';
      rows.push({
        ...node,
        displayOrder,
        level,
        rowType: isHeader ? 'subheader' : 'criterion'
      });
      if (isHeader) {
        (childrenMap.get(node.code) || []).forEach((child, index) =>
          appendNode(child, `${displayOrder}.${index + 1}`, level + 1)
        );
      }
    };

    const rootNodes = childrenMap.get('') || [];
        const rootHeaders = rootNodes.filter(node => node.inputType === 'HEADER');
        if (!rootHeaders.length) {
          rootNodes.forEach(node => {
           runningOrder++;
           appendNode(node, `${runningOrder}`, 1);
         });
        } else {
         rootNodes.forEach(root => {
           if (root.inputType === 'HEADER') {
             rows.push({ ...root, displayOrder: null, level: 0, rowType: 'header' });
             (childrenMap.get(root.code) || []).forEach(child => {
               runningOrder++;
               appendNode(child, `${runningOrder}`, 1);
             });
           } else {
             runningOrder++;
             appendNode(root, `${runningOrder}`, 1);
            }
         });
        }
        return rows;
  }

  toggleGroup(row: IReportCriterionRow) {
    row.expanded = !row.expanded;
    this.expandedGroups.set(row.treeKey, row.expanded);
  }

  isRowVisible(row: IReportCriterionRow): boolean {
    let parentTreeKey = row.parentTreeKey || '';
    while (parentTreeKey) {
      if (this.expandedGroups.get(parentTreeKey) === false) return false;
      parentTreeKey = this.parentTreeKeyMap.get(parentTreeKey) || '';
    }
    return true;
  }

  trackByTreeKey(_: number, row: IReportCriterionRow): string {
    return row.treeKey;
  }

  isHeaderRow = (_: number, row: IReportCriterionRow) => row.rowType === 'header';
  isCriterionRow = (_: number, row: IReportCriterionRow) => row.rowType !== 'header';

  getDisplayValue(element: any): string {
    const value = element && element.controlField ? element.controlField.value : null;
    if (value === null || value === undefined || value === '') return '';
    if (element.inputType === 'DATETIME') return dayjs(value).format('DD/MM/YYYY');
    if (element.inputType === 'DROPDOWN') {
      const options = this.optionsMap.get(element.id) || [];
      const selected = options.find(option => option.value == value);
      return selected ? selected.name : String(value);
    }
    return String(value);
  }
}
